var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Paths"},[React.createElement("circle",{"id":"Ellipse 36","cx":"12.0002","cy":"12","r":"10.8","stroke":"#E4C25E","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"id":"Star 1","d":"M12.0004 5.40002L13.8625 9.43706L18.2774 9.96051L15.0133 12.979L15.8798 17.3395L12.0004 15.168L8.12101 17.3395L8.98744 12.979L5.72342 9.96051L10.1383 9.43706L12.0004 5.40002Z","stroke":"#E4C25E","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

Star.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Star;

Star.default = Star;
